export default "__VITE_ASSET__4515a3a0__"